import { createContext } from "react";

export default (contextName) => {
  const Context = createContext(null);

  if (process.env.NODE_ENV !== "production") {
    Context.displayName = `${contextName}Context`;
  }

  return Context;
};
